import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "airtable",
  "name": "Airtable",
  "category": "integrations",
  "description": "Create and manage records in Airtable",
  "icon": "siAirtable",
  "iconType": "simple-icon",
  "color": "yellow",
  "version": "2.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Airtable",
    "color": "#ffbf00"
  },
  "credentials": [
    {
      "name": "airtableApi",
      "required": true,
      "displayName": "Airtable API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "airtable",
    "database",
    "spreadsheet",
    "records",
    "base"
  ],
  "comingSoon": true
};

export default definition;
